import { amapConfig } from '@/utils/amapConfig'

/**
 * 构建高德 WebService 静态地图 URL。
 * 不传 location/zoom：由服务端按 paths 自动包住整段轨迹，避免长途轨迹起终点被裁切。
 * size 上限 1024×1024（官方限制）；scale=2 输出更高清。
 */
export function buildAmapStaticMapUrlFromTrackPoints(pts, options = {}) {
  if (!pts || pts.length < 2 || !amapConfig.key) return null
  const maxPts = Math.max(2, Number(options.maxPts) || 200)
  const step = Math.max(1, Math.ceil(pts.length / maxPts))
  const coords = []
  const pushCoord = (p) => {
    if (!p || p.lon == null || p.lat == null) return
    const lng = Number(p.lon)
    const lat = Number(p.lat)
    if (!Number.isFinite(lng) || !Number.isFinite(lat)) return
    const next = `${lng.toFixed(6)},${lat.toFixed(6)}`
    if (coords.length && coords[coords.length - 1] === next) return
    coords.push(next)
  }
  pushCoord(pts[0])
  for (let i = step; i < pts.length - 1; i += step) {
    pushCoord(pts[i])
  }
  pushCoord(pts[pts.length - 1])
  if (coords.length < 2) return null

  const stroke = options.stroke || '8,0xFF0000,1,,'
  const paths = `${stroke}:${coords.join(';')}`
  const params = new URLSearchParams()
  params.set('key', amapConfig.key)
  params.set('size', options.size || '1024*1024')
  params.set('scale', String(options.scale != null ? options.scale : 2))
  params.set('paths', paths)
  return `https://restapi.amap.com/v3/staticmap?${params.toString()}`
}
